import { modalIds } from "constants/modals-constants";
import { useModal } from "hooks/useModal";
import type React from "react";
import { StyledModal } from "./SideMenuModal.styled";
import { SideMenu } from "./components/SideMenu";
import type { SideMenuProps } from "./components/SideMenu.model";

export const SideMenuModal: React.FC<SideMenuProps> = (props) => {
  const { closeModal, isModalOpen } = useModal();
  return (
    <StyledModal
      variant="side-modal"
      closeOnClickOutside
      dataCy={modalIds.modalSideMenu}
      isOpen={isModalOpen(modalIds.modalSideMenu)}
      modalAnimation={"slideLeft"}
      modalPosition={["center", "left"]}
      onClose={closeModal}
    >
      <SideMenu {...props} />
    </StyledModal>
  );
};
